/*
 * Ryan O'Dowd
 * 2022-04-13
 * © Copyright 2021 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Platform,
  TouchableOpacity, // @TODO: this should be exported from react-native-gesture-handler (isn't now because of a width issue)
  View,
} from 'react-native';
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Verse = (props: VerseProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <View style={styles.dragWrapper}>
        <TouchableOpacity
          disabled={props.answerSubmitted}
          onPressIn={props.drag}
        >
          <Icon style={styles.dragIcon} name='drag' />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.verseWrapper}
          disabled={props.answerSubmitted}
          onPressIn={Platform.OS === 'web' ? props.drag : undefined}
          onLongPress={Platform.OS === 'web' ? undefined : props.drag}
          delayLongPress={props.hasOverflow ? 200 : 0}
        >
          {props.answerSubmitted &&
            <Text style={[styles.verseNumberText, !props.isInCorrectIndex && styles.incorrectVerseNumberText]}>{props.verseNumber}</Text>
          }
          <Text style={styles.verseBodyText}>{props.verseBody}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

class VerseProps {
  answerSubmitted: boolean;
  isInCorrectIndex: boolean;
  hasOverflow: boolean;
  drag: () => void;
  verseBody: string;
  verseNumber: number;
};

export default Verse;
